import {Component, Input, OnInit} from '@angular/core';
import {IsFilterOnService} from '../../../../Services/is-filter-on.service';

@Component({
  selector: 'app-payment-type-select',
  templateUrl: './payment-type-select.component.html',
  styleUrls: ['./payment-type-select.component.css'],
  standalone: false
})
export class PaymentTypeSelectComponent implements OnInit {
  @Input() vm: any;
  constructor(public isFiltered: IsFilterOnService) { }

  ngOnInit() {
  }

  checkFiltered(): boolean {
    const filteredValue = this.isFiltered.isFiltered(this.vm);
    this.vm.filtered = filteredValue;
    return filteredValue;
  }

}
